import { useLang } from 'hooks/lang';

import { invoiceStatusConfig, projectInvoiceStatusConfig } from 'entities';

import { Column, Dot, Row, Tabs } from 'components/Blocks';
import { GoBackButton } from 'components/Buttons';

import { useUrlStateV2 } from 'hooks';

import { InvoiceProvider } from './context';
import { InvoiceStatuses } from './Statuses';

import { listGet } from 'utils/array';
import { StatusTabShortcuts } from './Shotcuts';

function Invoices() {
  const { t } = useLang();

  const tabs = [
    {
      value: 'pre-creation',
      label: projectInvoiceStatusConfig.readyToInvoice.getLabel(t),
      icon: <Dot color={projectInvoiceStatusConfig.readyToInvoice.color} />,
    },
    ...Object.values(invoiceStatusConfig)
      .sort((a, b) => a.order - b.order)
      .map(({ queryParam, getLabel, color }) => ({
        value: queryParam,
        label: getLabel(t),
        icon: <Dot color={color} />,
      })),
  ];

  const [{ status }, setQuery] = useUrlStateV2({
    status: {
      defaultValue: 'pre-creation',

      validate: (v) => !!listGet(tabs, v, 'value'),
    },
  });

  const changeStatus = (status: string) => setQuery({ status });

  return (
    <InvoiceProvider>
      <Column fullHeight>
        <Column gap="2">
          <h5 className="flex items-center gap-2 text-3xl font-medium leading-none text-primary phone:text-2xl">
            <GoBackButton to="invoiceHome" />

            {t('invoices')}
          </h5>

          <Row justifyContent="space-between">
            <Tabs
              tabs={tabs}
              onTabChange={changeStatus}
              value={status}
              type="highlighted"
              responsiveBreakpoint="PHONE"
              responsiveOverlay="pop-over"
            />

            <StatusTabShortcuts tabs={tabs} action={changeStatus} />
          </Row>
        </Column>

        <InvoiceStatuses tab={status} />
      </Column>
    </InvoiceProvider>
  );
}

export default Invoices;
